import styled from '../../../theme/styled-with-theme';
import { mediaQueries } from '../../../styles/media-queries';

import { GlImage } from '../../Image';

export const ImageWrapper = styled('div')`
  position: relative;
  width: 100%;
`;

export const BlogPostHeroImage = styled(GlImage)`
  flex: 1 1 auto;
  border-radius: ${({ theme }) => theme.borderRadius.block};

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.block_desktop};
  }
`;
